import React, { useEffect, useState } from 'react';
import { Song } from '../types';
import { useLanguage } from '../LanguageContext';
import './SongList.css';

interface SongListProps {
  onSelectSong: (song: Song) => void;
}

const SongList: React.FC<SongListProps> = ({ onSelectSong }) => {
  const { t } = useLanguage();
  const [songs, setSongs] = useState<Song[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/songs')
      .then(res => res.json())
      .then(data => {
        setSongs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="song-list">
      <header className="header">
        <div className="logo">
          <div className="logo-icon">🎵</div>
          <span className="logo-text">BeatApp</span>
        </div>
        <p className="logo-subtitle">WarsoWerk</p>
      </header>

      <div className="section-header">
        <h2 className="section-title">{t.songs.title}</h2>
        <p className="section-subtitle">
          {t.songs.title === 'Songs' ? 'Select a track to start playing' : 'Wähle einen Track zum Spielen'}
        </p>
      </div>

      {loading ? (
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>{t.common.loading}</p>
        </div>
      ) : (
        <div className="songs-grid">
          {songs.map((song, index) => (
            <button
              key={song.id}
              className="song-card"
              onClick={() => onSelectSong(song)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="song-cover">
                {song.coverUrl ? (
                  <img src={song.coverUrl} alt={song.title} />
                ) : (
                  <div className="cover-placeholder-lg">🎵</div>
                )}
                <div className="song-play-icon">▶</div>
              </div>
              <div className="song-info">
                <h3 className="song-title">{song.title}</h3>
                <p className="song-artist">{song.artistName || song.creator}</p>
                <div className="song-meta">
                  <span className="song-bpm">{song.beatMap?.bpm || '?'} BPM</span>
                  <span className="song-beats">{song.totalBeats || song.beatMap?.beats?.length || 0} {t.songs.beats}</span>
                </div>
              </div>
              <div className="song-arrow">→</div>
            </button>
          ))}
        </div>
      )}

      {!loading && songs.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">🎵</div>
          <h3>{t.songs.noSongs}</h3>
          <p>{t.songs.title === 'Songs' ? 'Add some MP3 files to get started' : 'Füge MP3 Dateien hinzu'}</p>
        </div>
      )}
    </div>
  );
};

export default SongList;
